<section class="line-item-modal-container">
    <div class="modal-header">
        <h5 class="modal-title pull-left">
            {{title}}
            <div class="text-small"></div>
        </h5>
        <a class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
        </a>
    </div>
    <div class="modal-body">
        <div class="modal-body__content">
            <div class="user-profile__form">
                <section>
                    <div class="card-body p-4">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th scope="col">Vendor #</th>
                                        <th scope="col">Mail Address</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container>
                                        <tr>
                                            <td>
                                                <select class="form-control" (change)="onVendorSelect($event)">
                                                    <option [ngValue]="null" selected disabled>Select a Vendor</option>
                                                    <option *ngFor="let value of uniqueVendors" [value]="value.code">{{value.code}}</option>
                                                </select>
                                            </td>
                                            <td>
                                                <span *ngIf="emails?.length != 4" class="bg-warning text-white">Please add valid email
                                                    address and press
                                                    enter to add multiple</span>
                                                <div>
                                                    <tag-input [(ngModel)]='emails' [maxItems]='4' placeholder="Enter email Address"></tag-input>
                                                </div>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div>
            <button type="button" class="btn btn-primary text-white" (click)="updateEmailInfo()">Save Details</button>
        </div>
    </div>
</section>